<template>
    <svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 300 300">

        <!-- backGround -->
        <rect width="100%" height="100%" fill="#501078 "/>

        <!-- TQ -->
        <g  class="lc_tqText" transform="translate(-15 2) scale(1)" fill="none" stroke-linecap="round"  stroke-linejoin="round">
            <!-- T Shape -->
            <g >
                <path d="M130,80
                     l -90,0
                     l 0,30
                     l 30,0
                     l 0,35
                     l 15,15
                     l 0,40
                     m -15,-30
                     l 0,45
                     l 30,0
                     l 0,-60
                     l -15,-15
                     m 0,-20
                     l 0, -10
                     l 0, 10
                     l 15, 15
                     l 0, -40
                     l -45, 0
                     l 75, 0
                     l 0, 15
                     l -15, 0
                    "/>
            </g>

            <!-- q shape -->
            <g >

                <path  d="m235,80
            l -50,0
            l -20,20
            l 10,10
            l 15,-15
            l 15,0
            l 0,15
            l -10,0
            l -5,5
            "/>

                <path d="m280,145
            l -30,0
            l 0,-15
            l -20,-20
            l -10,0
            l 0,-15
            l 15,0
            l 30,30
            l 0,5
            l 15,0
            l 0,-10
            l -40,-40
            l -10,0
            "/>

                <path d="M180,125
            l -5,5
            l 0,15
            l -15,0
            l 0,-20
            l 5,-5
            l -10,-10
            l -10,10
            l 0,55
            l 20,20
            l 10,-10
            l -15,-15
            l 0,-10
            l 15,0
            l 0,5
            l 20,20
            l 15,0
            "/>

                <path d="m250,185
            l 15,-15
            l 0,-10
            l 15,0
            l 0,15
            l -40,40
            l -55,0
            l -10,-10
            l 10,-10
            l 5,5
            l 45,0
            l 5,-5
            l -10,-10
            l 20,-20
            l 0,-5
            "/>



                <path d="m250,205
            l 25,25
            l 10,-10
            l -15,-15
            m 0, -20
            l 25,25
            "/>

            </g>

        </g>

        <!-- outside maze-->
        <g class="lc_maze" stroke-linecap="round"  stroke-linejoin="round" transform="translate(-15 2) scale(1)"  fill="none">

            <path d="m10,5
            l60,0
            l0,15
            l0,-15
            m15,0
            l60,0
            l0,15
            l0,-15
            m15,0
            l 15,0
            l0,15
            l0,-15
            l105,0
            l0,15
            l0,-15
            l32,0
        "/>

            <path d="m220,50
              l -75, 0
              l 0, 50
              l 35, -35
              l -20, 0
          "/>



            <path d="m130,65
              l -40,0
              l 0,-15
              l 25,0
              l 0,-15
              l 50,0
              l 0, -15
              l -65, 0
              l 0, 5
        "/>

            <path d="m75,65
              l -50,0
              l 0,60
              l 30,0
              l 0,15
              l -45,0
              l 0,-40
        "/>


            <path d="m75,50
              l -35,0
              l 0, 15
              l 0, -15
              l -30,0
              l 0,40
        "/>



            <path d="m10,35
              l 90,0
              l 0,-15
              m -15,0
              l -75,0
        "/>


            <path d="m160,20
              l 40,0
              m 20,0
              l 20,0
              l 0,15
              l -60,0
        "/>


            <path d="m195,65
              l 40,0
              l 0,-15
              l 15,0
              l 0,-30
              l 30,0
              l 0,30
              l -15,0
              l 0,-15
        "/>


            <path d="m295,65
              l -45,0
              l 45,45
              l 0,-30
              l -15,0
        "/>

            <path d="m295,50
              l 0,-30
              l 15,0
              l 0,105
              l -15,0
              l 0,15
        "/>

            <path d="m310,140
              l 0,60
              l -15,-15
              l 0,-30
        "/>

            <path d="m310,200
              l 0,15
              l -30,30
        "/>

            <path d="m220,230
              l 30,0
              l 30,30
              l 5,0
              l 25,-25
              l 0,40
              l -35,0
              l -30,-30
              l -25,0
              l 0,30
              l 30,0
              l -15,-15
        "/>


            <path d="m205,230
            l 0,45
            l -45,0
            l 0,-30
            l 30,0
            l 0,15
            l -15,0
            m 15,-15
            l 0,-15
            l -15,0
            l -45,-45
            l 0,-60
            l -15,0
            l 0,30
        "/>


            <path d="m115,170
             l0,60
             l30,0
             l0,-15
             l-15,0
             l0,-15
        "/>

            <path d="m10,155
            l45,0
            l0,45
            l-45,0
            l0,-30
            l30,0
            l0,15
            l-15,0
        "/>


            <path d="m10,215
            l45,0
            l0,15
            l45,0
            l0,15
            l-75,0
            l0,-15
            l15,0
            l-30,0
            l0,45
            l60,0
            l0,-15
            l-45,0
            l105,0
            l0,-15
            l-15,0
            l30,0
            l0,30
            l-60,0
        "/>

            <path d="m10,290
            l45,0
            l0,-15
            l0,15
            l60,0
            m15,0
            l60,0
            l0,-15
            l0,15
            l30,0
            m15,0
            l75,0
        "/>

            <!--<path d="m10,305-->
            <!--l60,0-->
            <!--l0,-15-->
            <!--l0,15-->
            <!--m15,0-->
            <!--l60,0-->
            <!--l0,-15-->
            <!--l0,15-->
            <!--m15,0-->
            <!--l 15,0-->
            <!--l0,-15-->
            <!--l0,15-->
            <!--l135,0-->
            <!--l0,-15-->
            <!--l-15,0-->
        <!--"/>-->


            <path d="m205,125
            l15,0
            l15,15
            l0,15
            l-45,0
            l0,-15
            l30,0
            m10,30
            l-30,0
            l-0,-15
        "/>


        </g>

    </svg>

</template>

<script>
    export default {
        name: "si_fullLogo"
    }
</script>

<style scoped lang="scss">

    .lc_tqText {
        stroke: #885ead;
        stroke-dasharray: 320;
        stroke-dashoffset: 320;
        animation: color 2s linear forwards;
        stroke-width: 4;
    }

    .lc_maze {
        stroke: #885ead;
        stroke-dasharray: 700;
        stroke-dashoffset: 0;
        //animation: dash 2s linear forwards;
        stroke-width: 4;

    }

    @keyframes dash {
        100% {
            //stroke-dashoffset: 0;
            stroke-width: 4;
        }
    }

    @keyframes color {
        60% {
            stroke-dashoffset : 0;
            stroke: #885ead;
        }
        100% {
            stroke-dashoffset : 0;
            stroke-width: 5;
            stroke: white;
        }

    }
</style>